import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "auth-manage" }
const _hoisted_2 = { class: "auth-tabs" }
const _hoisted_3 = {
  key: 0,
  class: "auth-section"
}
const _hoisted_4 = { class: "section-card" }
const _hoisted_5 = { class: "create-row" }
const _hoisted_6 = { class: "section-card fill" }
const _hoisted_7 = { class: "section-header" }
const _hoisted_8 = { class: "section-count" }
const _hoisted_9 = { class: "code-list" }
const _hoisted_10 = { class: "code-info" }
const _hoisted_11 = { class: "code-value" }
const _hoisted_12 = { class: "code-time" }
const _hoisted_13 = {
  key: 0,
  class: "empty-tip"
}
const _hoisted_14 = {
  key: 0,
  class: "pagination-wrap"
}
const _hoisted_15 = {
  key: 1,
  class: "auth-section"
}
const _hoisted_16 = { class: "section-card fill" }
const _hoisted_17 = { class: "section-header" }
const _hoisted_18 = { class: "section-count" }
const _hoisted_19 = { class: "filter-row" }
const _hoisted_20 = { class: "filter-item" }
const _hoisted_21 = { class: "filter-item" }
const _hoisted_22 = { class: "device-list" }
const _hoisted_23 = { class: "device-header" }
const _hoisted_24 = { class: "device-header-right" }
const _hoisted_25 = { class: "device-status-switch" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "meta-toggle-arrow" }
const _hoisted_28 = { class: "device-meta" }
const _hoisted_29 = { class: "meta-row" }
const _hoisted_30 = { class: "meta-value" }
const _hoisted_31 = ["title"]
const _hoisted_32 = { class: "meta-row" }
const _hoisted_33 = { class: "meta-value" }
const _hoisted_34 = ["disabled", "onClick"]
const _hoisted_35 = { class: "meta-row" }
const _hoisted_36 = {
  key: 0,
  class: "meta-value"
}
const _hoisted_37 = ["href", "title"]
const _hoisted_38 = {
  key: 2,
  class: "meta-value"
}
const _hoisted_39 = { class: "meta-row" }
const _hoisted_40 = {
  key: 0,
  class: "meta-closed-tag"
}
const _hoisted_41 = {
  key: 1,
  class: "meta-value"
}
const _hoisted_42 = { class: "meta-row" }
const _hoisted_43 = { class: "meta-row" }
const _hoisted_44 = { class: "meta-value" }
const _hoisted_45 = { class: "meta-row" }
const _hoisted_46 = { class: "meta-value" }
const _hoisted_47 = { class: "device-ops" }
const _hoisted_48 = {
  key: 0,
  class: "empty-tip"
}
const _hoisted_49 = {
  key: 0,
  class: "pagination-wrap"
}
const _hoisted_50 = {
  key: 0,
  class: "history-wrap"
}
const _hoisted_51 = { class: "history-head" }
const _hoisted_52 = { class: "history-head-main" }
const _hoisted_53 = ["title"]
const _hoisted_54 = { class: "history-meta" }
const _hoisted_55 = {
  key: 0,
  class: "history-meta"
}
const _hoisted_56 = {
  key: 1,
  class: "history-meta"
}
const _hoisted_57 = {
  key: 2,
  class: "history-meta"
}
const _hoisted_58 = { class: "history-head-ops" }
const _hoisted_59 = { class: "history-main" }
const _hoisted_60 = {
  key: 0,
  class: "history-side"
}
const _hoisted_61 = { class: "history-side-title" }
const _hoisted_62 = { class: "history-side-list" }
const _hoisted_63 = { class: "history-tab-head" }
const _hoisted_64 = ["href", "title"]
const _hoisted_65 = {
  key: 0,
  class: "history-tab-badge"
}
const _hoisted_66 = ["title"]
const _hoisted_67 = { class: "history-content" }
const _hoisted_68 = { class: "history-filters" }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "history-filter-count" }
const _hoisted_71 = { class: "history-list" }
const _hoisted_72 = { class: "history-time" }
const _hoisted_73 = { class: "history-body" }
const _hoisted_74 = ["href", "title"]
const _hoisted_75 = {
  key: 1,
  class: "history-text"
}
const _hoisted_76 = { class: "history-duration" }
const _hoisted_77 = ["title"]
const _hoisted_78 = {
  key: 0,
  class: "history-empty"
}
const _hoisted_79 = {
  key: 1,
  class: "history-empty"
}
const _hoisted_80 = { class: "history-footer" }
const _hoisted_81 = { class: "history-total" }
const _hoisted_82 = {
  key: 0,
  class: "shot-empty"
}
const _hoisted_83 = {
  key: 1,
  class: "shot-empty"
}
const _hoisted_84 = {
  key: 2,
  class: "shot-grid"
}
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "shot-card-img" }
const _hoisted_87 = ["src"]
const _hoisted_88 = {
  key: 0,
  class: "shot-card-badge"
}
const _hoisted_89 = { class: "shot-card-meta" }
const _hoisted_90 = { class: "shot-card-time" }
const _hoisted_91 = { class: "shot-footer" }
const _hoisted_92 = { class: "shot-meta" }
const _hoisted_93 = { class: "shot-wrap" }
const _hoisted_94 = ["src"]
const _hoisted_95 = { class: "shot-footer" }
const _hoisted_96 = { class: "shot-meta" }
const _hoisted_97 = { class: "shot-actions" }
const _hoisted_98 = ["href"]

import { ref, computed, onMounted, onUnmounted } from 'vue';
import {
  NInput,
  NButton,
  NSelect,
  NTag,
  NSwitch,
  NPagination,
  NPopconfirm,
  NDrawer,
  NDrawerContent,
  NModal,
  createDiscreteApi,
} from 'naive-ui';
import Tools from '@/ts/Tools';
import SignalRClient from '@/ts/SignalRClient';
import Config from '@/ts/Config';

const codeLimit = 20;

const deviceLimit = 20;
type DeviceLiveState = {
  deviceId: string;
  online: boolean;
  /** 浏览器窗口数量：0=窗口已全部关闭（扩展可能仍在后台常驻），-1=未知 */
  windowCount?: number;
  /** 在线且有至少一个浏览器窗口 */
  browserOpen?: boolean;
  ip?: string;
  region?: string;
  /** 插件版本号（扩展 WebSocket 的 ver= 参数上报） */
  version?: string;
  pageUrl?: string;
  pageTitle?: string;
  devtoolsOpen?: boolean;
  devtoolsCount?: number;
  devtoolsLastTime?: number;
  lastSeen?: number;
  /** 主地址延迟（毫秒）：-1=未知/离线 */
  latency?: number;
  /** 线路地址延迟（毫秒）：-1=未知/离线/与主地址相同 */
  latencyLine?: number;
};

/**
 * 设备展示态：
 * on=在线（有浏览器窗口） / closed=浏览器已关闭（扩展后台常驻，连接还在） / off=离线
 */
type LatencyTone = 'lat-good' | 'lat-warn' | 'lat-bad';

/**
 * 主地址配色：走的是 WebSocket 往返，数值最小
 * <=60ms 绿 / <=150ms 黄 / 其余红
 */
type DeviceScreenshot = { deviceId: string; url: string; ts: number };


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthManage',
  setup(__props) {

const api = createDiscreteApi(['message']);

// ---- 子标签 ----
const subTab = ref<'codes' | 'devices'>('devices');

// ========== 授权码管理 ==========
const newCode = ref('');
const creating = ref(false);
const codeList = ref<any[]>([]);
const codePage = ref(1);
const codeTotal = ref(0);
const codeTotalPages = ref(1);
async function loadCodeList(page: number = 1) {
  Tools.FetchGetAsync<{
    total: number;
    page: number;
    limit: number;
    total_pages: number;
    list: any[];
  }>('auth/list-codes', { page, limit: codeLimit }).then((resp) => {
    if (resp.CheckIsOk()) {
      codeList.value = resp.Data?.list ?? [];
      codeTotal.value = resp.Data?.total ?? 0;
      codeTotalPages.value = resp.Data?.total_pages ?? 1;
      codePage.value = page;
    }
  });
}

async function handleCreateCode() {
  const code = newCode.value.trim();
  if (!code) {
    Tools.AlertError('授权码不能为空');
    return;
  }
  creating.value = true;
  Tools.FetchAsync('auth/create-code', { code }, 'POST').then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess('授权码创建成功');
      newCode.value = '';
      loadCodeList(codePage.value);
    }
    creating.value = false;
  }).catch(() => { creating.value = false; });
}

async function handleDeleteCode(id: number) {
  Tools.FetchGetAsync('auth/delete-code', { id }).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess('删除成功');
      loadCodeList(codePage.value);
    }
  });
}

// ========== 设备管理 ==========
const deviceList = ref<any[]>([]);

// 设备卡片默认精简显示（授权码 / 当前页面 / 所在地区），展开后显示全部信息
const expandedDevices = ref<Record<string, boolean>>({});

function isDeviceExpanded(item: any) {
  return !!expandedDevices.value[item.device_id];
}

function toggleDeviceExpanded(item: any) {
  const key = item.device_id;
  expandedDevices.value[key] = !expandedDevices.value[key];
}

const devicePage = ref(1);
const deviceTotal = ref(0);
const deviceTotalPages = ref(1);
const deviceStatusFilter = ref(-1);
const deviceSort = ref('bind_time');

const statusOptions = [
  { label: '全部', value: -1 },
  { label: '已启用', value: 1 },
  { label: '已禁用', value: 0 },
];

const sortOptions = [
  { label: '绑定时间 ↓', value: 'bind_time' },
  { label: '最后登录 ↓', value: 'last_login' },
  { label: '状态优先', value: 'status' },
];

async function loadDeviceList(page: number = 1) {
  Tools.FetchGetAsync<{
    total: number;
    page: number;
    limit: number;
    total_pages: number;
    list: any[];
  }>('auth/list-devices', {
    page,
    limit: deviceLimit,
    status: deviceStatusFilter.value,
    sort: deviceSort.value,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      deviceList.value = resp.Data?.list ?? [];
      deviceTotal.value = resp.Data?.total ?? 0;
      deviceTotalPages.value = resp.Data?.total_pages ?? 1;
      devicePage.value = page;
    }
  });
}

async function handleToggleStatus(item: any, enabled: boolean) {
  const newStatus = enabled ? 1 : 0;
  Tools.FetchAsync('auth/set-device-status', { id: item.id, status: newStatus }, 'POST').then((resp) => {
    if (resp.CheckIsOk()) {
      item.status = newStatus;
      Tools.AlertSuccess(enabled ? '设备已启用' : '设备已禁用');
    }
  });
}

async function handleDeleteDevice(id: number) {
  Tools.FetchGetAsync('auth/delete-device', { id }).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess('设备已删除');
      loadDeviceList(devicePage.value);
    }
  });
}

// ========== 实时状态（服务端 SignalR 推送） ==========
function deviceStateClass(item: any): 'on' | 'closed' | 'off' {
  if (!item?.online) return 'off';
  // 旧接口没有 browser_open 字段时，按原来的在线处理
  return item.browser_open === false ? 'closed' : 'on';
}

function deviceStateText(item: any): string {
  const tag = deviceStateClass(item);
  if (tag === 'on') return '在线';
  if (tag === 'closed') return '浏览器已关闭';
  return '离线';
}

/**
 * 延迟（毫秒，插件测得）
 * - latency    = 主地址（插件内置 API，WebSocket 往返）
 * - latency_line = 线路地址（业务实际域名，HTTP 往返）；与主地址相同时为 -1
 * -1 均表示未知（离线 / 旧版扩展未上报 / 刚连上还没测到）
 */
function latencyValue(item: any): number {
  const n = Number(item?.latency);
  return Number.isFinite(n) && n >= 0 ? Math.round(n) : -1;
}

function latencyLineValue(item: any): number {
  const n = Number(item?.latency_line);
  return Number.isFinite(n) && n >= 0 ? Math.round(n) : -1;
}

function latencyMainClass(item: any): LatencyTone {
  const ms = latencyValue(item);
  if (ms <= 60) return 'lat-good';
  if (ms <= 150) return 'lat-warn';
  return 'lat-bad';
}

/**
 * 线路配色：走的是到线路域名的 HTTP 往返（含 DNS / TLS / 服务端处理），
 * 天然比 WS 往返大，阈值放宽，避免清一色飘红
 * <=150ms 绿 / <=350ms 黄 / 其余红
 */
function latencyLineClass(item: any): LatencyTone {
  const ms = latencyLineValue(item);
  if (ms <= 150) return 'lat-good';
  if (ms <= 350) return 'lat-warn';
  return 'lat-bad';
}

// ---- 历史记录全屏面板 ----
const showHistory = ref(false);
const historyDevice = ref<any>(null);
const historyTabs = ref<any[]>([]);
const historyList = ref<any[]>([]);
const historyPage = ref(1);
const historyPageSize = ref(50);
const historyTotal = ref(0);
const historyLoading = ref(false);

/**
 * 事件分类：一个分类 = 服务端的一组 event_type（与 AuthController.DeviceHistoryEventGroups 保持一致）。
 * 历史记录里浏览页面会刷屏，上下线/调试器/遥控指令才是关键动作，必须能分开看。
 */
const historyGroups: Array<{ key: string; label: string; types: string[] }> = [
  { key: 'all', label: '全部', types: [] },
  { key: 'page', label: '浏览页面', types: ['page'] },
  { key: 'presence', label: '上下线', types: ['online', 'offline'] },
  { key: 'devtools', label: '调试器', types: ['devtools_open', 'devtools_close'] },
  { key: 'cmd', label: '遥控指令', types: ['cmd_close', 'cmd_reload'] },
  { key: 'latency', label: '测速', types: ['latency'] },
];
const historyFilter = ref('all');
/** 各 event_type 的条数（服务端返回未过滤的统计，这里按分类聚合） */
const historyEventCounts = ref<Record<string, number>>({});
/** 全部分类的总条数（切换分类时「全部」标签上的数字保持不变） */
const historyTotalAll = ref(0);

const historyGroupCounts = computed<Record<string, number>>(() => {
  const src = historyEventCounts.value || {};
  const out: Record<string, number> = { all: historyTotalAll.value };
  for (const g of historyGroups) {
    if (g.key === 'all') continue;
    out[g.key] = g.types.reduce((sum, t) => sum + (src[t] || 0), 0);
  }
  return out;
});

/** 设备当前正在浏览的地址（来自插件上报的 page.url） */
const activePageUrl = computed(() => String(historyDevice.value?.page_url || ''));

function normalizeTabUrl(url: string): string {
  return String(url || '').split('#')[0];
}

/** 是否为当前激活标签页（插件把 page.url 截 2000、tabs.url 截 1000，故做前缀兼容） */
function isCurrentTab(tab: any): boolean {
  const cur = normalizeTabUrl(activePageUrl.value);
  const url = normalizeTabUrl(tab?.url);
  if (!cur || !url) return false;
  return url === cur || url.startsWith(cur) || cur.startsWith(url);
}

/** 当前页置顶，其余保持插件上报顺序（Array.sort 稳定） */
const sortedHistoryTabs = computed(() => {
  return [...(historyTabs.value || [])].sort(
    (a, b) => Number(isCurrentTab(b)) - Number(isCurrentTab(a))
  );
});

function applyDeviceState(st: DeviceLiveState) {
  if (!st || !st.deviceId) return;
  const item = deviceList.value.find((x: any) => x.device_id === st.deviceId);
  if (!item) return; // 不在当前页，切换页码/刷新后会拉到

  item.online = !!st.online;
  if (st.windowCount !== undefined) item.window_count = st.windowCount;
  if (st.browserOpen !== undefined) item.browser_open = st.browserOpen;
  if (st.ip) item.ip = st.ip;
  if (st.region) item.region = st.region;
  if (st.version) item.version = st.version;
  if (st.pageUrl !== undefined) item.page_url = st.pageUrl;
  if (st.pageTitle !== undefined) item.page_title = st.pageTitle;
  if (st.openTabs) {
    item.open_tabs = st.openTabs;
    item.open_tab_count = st.openTabs.length;
    if (historyDevice.value && historyDevice.value.device_id === st.deviceId) {
      historyTabs.value = st.openTabs;
    }
  }
  item.devtools_open = st.devtoolsOpen ? 1 : 0;
  if (st.devtoolsCount != null) item.devtools_count = st.devtoolsCount;
  if (st.devtoolsLastTime != null) item.devtools_last_time = st.devtoolsLastTime;
  if (st.lastSeen != null) item.last_seen_time = st.lastSeen;
  if (st.latency != null) item.latency = st.latency;
  if (st.latencyLine != null) item.latency_line = st.latencyLine;
}

SignalRClient.Instance.AddEventListener('onDeviceUpdate', applyDeviceState);
onUnmounted(() => SignalRClient.Instance.RemoveEventListener('onDeviceUpdate'));

// ---- 拍照（遥控器下发指令 → 插件截屏 → 上传 → SignalR 推回图片地址） ----
const screenshotVisible = ref(false);
const screenshotUrl = ref('');
const screenshotDeviceId = ref('');
const screenshotAt = ref(0);
const screenshotLoadingId = ref('');

// ---- 截图查看 ----
// 截图弹窗固定铺满当前窗口（100vw/100vh），不调用浏览器 Fullscreen API，
// 避免把整个浏览器切到全屏模式。
async function handleCaptureScreenshot(item: any) {
  if (!item?.device_id) return;
  screenshotLoadingId.value = item.device_id;
  try {
    const resp = await SignalRClient.Instance.InvokeAsync<{ flag: boolean; errorMessage: string }>(
      'CaptureScreenshot',
      item.device_id
    );
    if (!resp?.flag) {
      Tools.AlertError(resp?.errorMessage || '指令发送失败，设备可能不在线');
    } else {
      Tools.AlertSuccess('拍照指令已发送，请稍候…');
      armScreenshotTimeout(item.device_id);
    }
  } catch (e: any) {
    Tools.AlertError(e?.message || '拍照指令发送失败');
  } finally {
    screenshotLoadingId.value = '';
  }
}

// ---- 立即测速 ----
const latencyTestingId = ref('');

/**
 * 让设备马上测一次延迟（向设备下发 speedtest 指令）。
 * 测完扩展会通过 WS + HTTP 上报，服务端广播 onDeviceUpdate，列表自动刷新。
 */
async function handleTestLatency(item: any) {
  if (!item?.device_id || latencyTestingId.value) return;
  latencyTestingId.value = item.device_id;

  try {
    const resp = await SignalRClient.Instance.InvokeAsync<{ flag: boolean; errorMessage: string }>(
      'TestLatency',
      item.device_id
    );
    if (!resp?.flag) Tools.AlertError(resp?.errorMessage || '测速指令发送失败，设备可能不在线');
  } catch (e: any) {
    Tools.AlertError(e?.message || '测速指令发送失败');
  } finally {
    // 给设备留出测量+上报的时间，再恢复按钮
    window.setTimeout(() => {
      if (latencyTestingId.value === item.device_id) latencyTestingId.value = '';
    }, 2000);
  }
}

function onDeviceScreenshot(st: DeviceScreenshot) {
  if (!st?.url) return;
  clearScreenshotTimeout();
  screenshotUrl.value = `${Config.ORIGIN}${st.url}`;
  screenshotDeviceId.value = st.deviceId;
  screenshotAt.value = st.ts || 0;
  screenshotVisible.value = true;
}

SignalRClient.Instance.AddEventListener('onDeviceScreenshot', onDeviceScreenshot);
onUnmounted(() => SignalRClient.Instance.RemoveEventListener('onDeviceScreenshot'));

// 截图失败：服务端把插件的 ack error 转发过来（窗口最小化、无活动标签、上传失败等）
function onDeviceScreenshotFailed(st: { deviceId: string; error: string }) {
  clearScreenshotTimeout();
  Tools.AlertError(`截图失败：${st?.error || '未知原因'}`);
}

SignalRClient.Instance.AddEventListener('onDeviceScreenshotFailed', onDeviceScreenshotFailed);
onUnmounted(() => SignalRClient.Instance.RemoveEventListener('onDeviceScreenshotFailed'));

// 拍照超时：避免只提示“已发送”后一直没有任何反馈
let shotTimeoutTimer: ReturnType<typeof setTimeout> | null = null;

function armScreenshotTimeout(deviceId: string) {
  clearScreenshotTimeout();
  shotTimeoutTimer = setTimeout(() => {
    shotTimeoutTimer = null;
    Tools.AlertError(
      `拍照超时：${String(deviceId).slice(0, 8)}… 20 秒内未收到截图，请确认浏览器窗口可见且未最小化`
    );
  }, 20000);
}

function clearScreenshotTimeout() {
  if (shotTimeoutTimer) {
    clearTimeout(shotTimeoutTimer);
    shotTimeoutTimer = null;
  }
}

onUnmounted(clearScreenshotTimeout);

// ---- 截图记录（错过推送时可回看，每台设备最多 20 张） ----
const shotListVisible = ref(false);
const shotListLoading = ref(false);
const shotListDeviceId = ref('');
const shotList = ref<{ url: string; ts: number }[]>([]);

async function openScreenshotList(item: any) {
  if (!item?.device_id) return;
  shotListDeviceId.value = item.device_id;
  shotList.value = [];
  shotListVisible.value = true;
  shotListLoading.value = true;
  try {
    const list = await SignalRClient.Instance.InvokeAsync<{ url: string; ts: number }[]>(
      'GetDeviceScreenshots',
      item.device_id,
      20
    );
    shotList.value = (list || []).map((s) => ({
      url: s.url?.startsWith('http') ? s.url : `${Config.ORIGIN}${s.url}`,
      ts: s.ts
    }));
  } catch (e: any) {
    Tools.AlertError(e?.message || '读取截图记录失败');
  } finally {
    shotListLoading.value = false;
  }
}

function previewShot(url: string, ts: number) {
  screenshotUrl.value = url;
  screenshotDeviceId.value = shotListDeviceId.value;
  screenshotAt.value = ts || 0;
  shotListVisible.value = false;
  screenshotVisible.value = true;
}

// ---- 遥控操作 ----
async function handleCloseBrowser(item: any) {
  try {
    const resp = await SignalRClient.Instance.InvokeAsync<{ flag: boolean; errorMessage: string }>(
      'CloseBrowser',
      item.device_id
    );
    if (resp?.flag) Tools.AlertSuccess('关闭指令已发送');
    else Tools.AlertError(resp?.errorMessage || '指令发送失败');
  } catch (e: any) {
    Tools.AlertError(e?.message || '指令发送失败');
  }
}

async function handleReloadBrowser(item: any) {
  try {
    const resp = await SignalRClient.Instance.InvokeAsync<{ flag: boolean; errorMessage: string }>(
      'ReloadBrowser',
      item.device_id
    );
    if (resp?.flag) Tools.AlertSuccess('刷新指令已发送');
    else Tools.AlertError(resp?.errorMessage || '指令发送失败');
  } catch (e: any) {
    Tools.AlertError(e?.message || '指令发送失败');
  }
}

// ---- 历史记录 ----
function eventLabel(type: string): string {
  const map: Record<string, string> = {
    page: '浏览页面',
    online: '设备上线',
    offline: '设备离线',
    devtools_open: '打开调试器',
    devtools_close: '关闭调试器',
    cmd_close: '遥控关闭浏览器',
    cmd_reload: '遥控刷新浏览器',
    latency: '测速',
  };
  return map[type] || type;
}

function openHistory(item: any) {
  historyDevice.value = item;
  historyTabs.value = item.open_tabs ?? [];
  historyList.value = [];
  historyTotal.value = 0;
  historyTotalAll.value = 0;
  historyEventCounts.value = {};
  historyFilter.value = 'all';
  historyPage.value = 1;
  showHistory.value = true;
  loadHistory(1, historyPageSize.value);
}

/** 切换事件分类：回到第 1 页按该分类重新拉取 */
function handleHistoryFilter(key: string) {
  if (historyFilter.value === key) return;
  historyFilter.value = key;
  loadHistory(1, historyPageSize.value);
}

async function loadHistory(page: number = 1, pageSize: number = historyPageSize.value) {
  if (!historyDevice.value) return;
  historyLoading.value = true;
  try {
    const params: Record<string, any> = {
      deviceId: historyDevice.value.device_id,
      page,
      pageSize,
    };
    // 只传分类，让服务端先过滤再分页（否则只过滤当前页，总数与页码都是错的）
    if (historyFilter.value !== 'all') params.eventType = historyFilter.value;

    const resp = await Tools.FetchGetAsync<{
      total: number;
      total_all?: number;
      page: number;
      page_size: number;
      counts?: Record<string, number>;
      list: any[];
    }>('auth/device-history', params);
    if (resp.CheckIsOk()) {
      historyList.value = resp.Data?.list ?? [];
      historyTotal.value = resp.Data?.total ?? 0;
      historyTotalAll.value = resp.Data?.total_all ?? resp.Data?.total ?? 0;
      historyEventCounts.value = resp.Data?.counts ?? {};
      historyPage.value = resp.Data?.page ?? page;
      historyPageSize.value = resp.Data?.page_size ?? pageSize;
    }
  } catch (e: any) {
    Tools.AlertError(e?.message || '加载历史记录失败');
  } finally {
    historyLoading.value = false;
  }
}

function handleHistoryPageChange(page: number) {
  loadHistory(page, historyPageSize.value);
}

function handleHistoryPageSizeChange(pageSize: number) {
  loadHistory(1, pageSize);
}

// ---- 工具函数 ----
function formatDuration(seconds: number | null | undefined): string {
  if (seconds == null || seconds < 0) return '-';
  if (seconds < 60) return seconds + ' 秒';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return minutes + ' 分 ' + (seconds % 60) + ' 秒';
  const hours = Math.floor(minutes / 60);
  return hours + ' 时 ' + (minutes % 60) + ' 分';
}

function formatTime(unix: number | null | undefined): string {
  if (!unix) return '-';
  const date = new Date(unix * 1000);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');
  return `${y}-${m}-${d} ${h}:${min}:${s}`;
}

// SignalR 断线期间会丢失上线/离线推送，用 HTTP 定时兜底校准在线状态
let deviceRefreshTimer = 0;

function refreshDevicesSilently() {
  if (document.visibilityState === 'hidden') return;
  loadDeviceList(devicePage.value);
}

function handleVisibilityChange() {
  if (document.visibilityState === 'visible') refreshDevicesSilently();
}

onMounted(() => {
  loadCodeList();
  loadDeviceList();
  deviceRefreshTimer = window.setInterval(refreshDevicesSilently, 60000);
  document.addEventListener('visibilitychange', handleVisibilityChange);
  SignalRClient.Instance.AddReconnectListener(refreshDevicesSilently);
});

onUnmounted(() => {
  if (deviceRefreshTimer) {
    clearInterval(deviceRefreshTimer);
    deviceRefreshTimer = 0;
  }
  document.removeEventListener('visibilitychange', handleVisibilityChange);
  SignalRClient.Instance.RemoveReconnectListener(refreshDevicesSilently);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["auth-tab", { active: subTab.value === 'devices' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (subTab.value = 'devices'))
      }, " 设备管理 ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["auth-tab", { active: subTab.value === 'codes' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (subTab.value = 'codes'))
      }, " 授权码管理 ", 2)
    ]),
    (subTab.value === 'codes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "section-header" }, [
              _createElementVNode("span", { class: "section-title" }, "创建授权码")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(NInput), {
                value: newCode.value,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((newCode).value = $event)),
                placeholder: "输入授权码（支持任意字符）",
                size: "large",
                onKeyup: _withKeys(handleCreateCode, ["enter"])
              }, null, 8, ["value"]),
              _createVNode(_unref(NButton), {
                type: "primary",
                size: "large",
                onClick: handleCreateCode,
                loading: creating.value
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode(" 创建 ")
                ])),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "section-title" }, "未使用授权码", -1)),
              _createElementVNode("span", _hoisted_8, "共 " + _toDisplayString(codeTotal.value) + " 个", 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codeList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "code-item",
                  key: item.id
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.code), 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(formatTime(item.create_time)), 1)
                  ]),
                  _createVNode(_unref(NPopconfirm), {
                    onPositiveClick: ($event: any) => (handleDeleteCode(item.id!))
                  }, {
                    trigger: _withCtx(() => [
                      _createVNode(_unref(NButton), {
                        size: "small",
                        type: "error",
                        quaternary: ""
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("删除")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 确定删除授权码 \"" + _toDisplayString(item.code) + "\" 吗？ ", 1)
                    ]),
                    _: 2
                  }, 1032, ["onPositiveClick"])
                ]))
              }), 128)),
              (codeList.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "暂无未使用的授权码"))
                : _createCommentVNode("", true)
            ]),
            (codeTotalPages.value > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_unref(NPagination), {
                    page: codePage.value,
                    "onUpdate:page": [
                      _cache[3] || (_cache[3] = ($event: any) => ((codePage).value = $event)),
                      loadCodeList
                    ],
                    "page-count": codeTotalPages.value,
                    "page-slot": 5,
                    size: "small"
                  }, null, 8, ["page", "page-count"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (subTab.value === 'devices')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "section-title" }, "已绑定设备", -1)),
              _createElementVNode("span", _hoisted_18, "共 " + _toDisplayString(deviceTotal.value) + " 台", 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "filter-label" }, "状态", -1)),
                _createVNode(_unref(NSelect), {
                  value: deviceStatusFilter.value,
                  "onUpdate:value": [
                    _cache[4] || (_cache[4] = ($event: any) => ((deviceStatusFilter).value = $event)),
                    _cache[5] || (_cache[5] = ($event: any) => (loadDeviceList(1)))
                  ],
                  options: statusOptions,
                  size: "small",
                  style: {"width":"100px"}
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "filter-label" }, "排序", -1)),
                _createVNode(_unref(NSelect), {
                  value: deviceSort.value,
                  "onUpdate:value": [
                    _cache[6] || (_cache[6] = ($event: any) => ((deviceSort).value = $event)),
                    _cache[7] || (_cache[7] = ($event: any) => (loadDeviceList(1)))
                  ],
                  options: sortOptions,
                  size: "small",
                  style: {"width":"140px"}
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "device-item",
                  key: item.id
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["online-dot", deviceStateClass(item)])
                    }, null, 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(["online-text", deviceStateClass(item)])
                    }, _toDisplayString(deviceStateText(item)), 3),
                    (item.devtools_open)
                      ? (_openBlock(), _createBlock(_unref(NTag), {
                          key: 0,
                          type: "error",
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createTextVNode("调试器已开启")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(NTag), {
                      type: item.status === 1 ? 'success' : 'error',
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.status === 1 ? '已启用' : '已禁用'), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"]),
                    _createElementVNode("span", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, [
                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "device-action-label" }, "启用", -1)),
                        _createVNode(_unref(NSwitch), {
                          size: "small",
                          value: item.status === 1,
                          "onUpdate:value": (val) => handleToggleStatus(item, val)
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "meta-toggle",
                        onClick: ($event: any) => (toggleDeviceExpanded(item))
                      }, [
                        _createTextVNode(_toDisplayString(isDeviceExpanded(item) ? '收起' : '展开全部') + " ", 1),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(isDeviceExpanded(item) ? '▴' : '▾'), 1)
                      ], 8, _hoisted_26)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[23] || (_cache[23] = _createElementVNode("span", { class: "meta-label" }, "授权码", -1)),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(item.auth_code), 1),
                      _cache[24] || (_cache[24] = _createElementVNode("span", { class: "meta-label meta-label-sub" }, "版本", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["meta-value meta-version", { 'is-old': !item.version }]),
                        title: item.version ? `插件版本 v${item.version}` : '未上报版本号，可能是老版本插件'
                      }, _toDisplayString(item.version ? 'v' + item.version : '老版本'), 11, _hoisted_31)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "meta-label" }, "IP / 地区", -1)),
                      _createElementVNode("span", _hoisted_33, [
                        _createTextVNode(_toDisplayString(item.ip || '-') + " ", 1),
                        (item.region)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" · " + _toDisplayString(item.region), 1)
                            ], 64))
                          : _createCommentVNode("", true),
                        (latencyValue(item) >= 0 || latencyLineValue(item) >= 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[25] || (_cache[25] = _createTextVNode(" · ")),
                              (latencyValue(item) >= 0)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["latency", latencyMainClass(item)]),
                                    title: "主地址：WebSocket 往返"
                                  }, _toDisplayString(latencyLineValue(item) >= 0 ? '主 ' : '') + _toDisplayString(latencyValue(item)) + "ms", 3))
                                : _createCommentVNode("", true),
                              (latencyValue(item) >= 0 && latencyLineValue(item) >= 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" · ")
                                  ], 64))
                                : _createCommentVNode("", true),
                              (latencyLineValue(item) >= 0)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 2,
                                    class: _normalizeClass(["latency", latencyLineClass(item)]),
                                    title: "线路：到线路域名的 HTTP 首字节耗时（含 CDN 鉴权/回源，通常大于 ping 值；ping 只测网络往返）"
                                  }, "线 " + _toDisplayString(latencyLineValue(item)) + "ms", 3))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["lat-test", { busy: latencyTestingId.value === item.device_id }]),
                          disabled: deviceStateClass(item) !== 'on' || latencyTestingId.value === item.device_id,
                          title: "立即测速",
                          onClick: _withModifiers(($event: any) => (handleTestLatency(item)), ["stop"])
                        }, _toDisplayString(latencyTestingId.value === item.device_id ? '测速中' : '测速'), 11, _hoisted_34)
                      ])
                    ]),
                    (isDeviceExpanded(item))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_35, [
                            _cache[27] || (_cache[27] = _createElementVNode("span", { class: "meta-label" }, "当前页面", -1)),
                            (deviceStateClass(item) === 'closed')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, "-"))
                              : (item.page_url)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "meta-link",
                                    href: item.page_url,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    title: item.page_url
                                  }, _toDisplayString(item.page_title || item.page_url), 9, _hoisted_37))
                                : (_openBlock(), _createElementBlock("span", _hoisted_38, "-"))
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _cache[28] || (_cache[28] = _createElementVNode("span", { class: "meta-label" }, "打开页面", -1)),
                            (deviceStateClass(item) === 'closed')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, "浏览器已关闭"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(item.open_tab_count || 0) + " 个", 1))
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "meta-label" }, "调试器", -1)),
                            _createElementVNode("span", {
                              class: _normalizeClass(["meta-value", { danger: item.devtools_open }])
                            }, [
                              _createTextVNode(_toDisplayString(item.devtools_open ? '已开启' : '未开启') + " ", 1),
                              (item.devtools_count)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode("（累计 " + _toDisplayString(item.devtools_count) + " 次）", 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "meta-label" }, "最后心跳", -1)),
                            _createElementVNode("span", _hoisted_44, _toDisplayString(formatTime(item.last_seen_time)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _cache[31] || (_cache[31] = _createElementVNode("span", { class: "meta-label" }, "绑定时间", -1)),
                            _createElementVNode("span", _hoisted_46, _toDisplayString(formatTime(item.bind_time)), 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_unref(NButton), {
                      size: "small",
                      secondary: "",
                      type: "primary",
                      loading: screenshotLoadingId.value === item.device_id,
                      disabled: deviceStateClass(item) !== 'on',
                      onClick: ($event: any) => (handleCaptureScreenshot(item))
                    }, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode("拍照")
                      ])),
                      _: 2
                    }, 1032, ["loading", "disabled", "onClick"]),
                    _createVNode(_unref(NPopconfirm), {
                      onPositiveClick: ($event: any) => (handleDeleteDevice(item.id!))
                    }, {
                      trigger: _withCtx(() => [
                        _createVNode(_unref(NButton), {
                          class: "ops-delete",
                          size: "small",
                          secondary: "",
                          type: "error"
                        }, {
                          default: _withCtx(() => _cache[33] || (_cache[33] = [
                            _createTextVNode("删除")
                          ])),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _cache[34] || (_cache[34] = _createTextVNode(" 确定删除该设备吗？ ")),
                        _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                        _cache[36] || (_cache[36] = _createTextVNode(" 删除后该设备将无法使用插件。 "))
                      ]),
                      _: 2
                    }, 1032, ["onPositiveClick"]),
                    (isDeviceExpanded(item))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_unref(NButton), {
                            size: "small",
                            secondary: "",
                            onClick: ($event: any) => (openHistory(item))
                          }, {
                            default: _withCtx(() => _cache[37] || (_cache[37] = [
                              _createTextVNode("历史记录")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_unref(NButton), {
                            size: "small",
                            secondary: "",
                            onClick: ($event: any) => (openScreenshotList(item))
                          }, {
                            default: _withCtx(() => _cache[38] || (_cache[38] = [
                              _createTextVNode("截图记录")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_unref(NPopconfirm), {
                            onPositiveClick: ($event: any) => (handleReloadBrowser(item))
                          }, {
                            trigger: _withCtx(() => [
                              _createVNode(_unref(NButton), {
                                size: "small",
                                secondary: "",
                                type: "warning",
                                disabled: deviceStateClass(item) !== 'on'
                              }, {
                                default: _withCtx(() => _cache[39] || (_cache[39] = [
                                  _createTextVNode("刷新浏览器")
                                ])),
                                _: 2
                              }, 1032, ["disabled"])
                            ]),
                            default: _withCtx(() => [
                              _cache[40] || (_cache[40] = _createTextVNode(" 确定让该设备刷新所有标签页吗？ "))
                            ]),
                            _: 2
                          }, 1032, ["onPositiveClick"]),
                          _createVNode(_unref(NPopconfirm), {
                            onPositiveClick: ($event: any) => (handleCloseBrowser(item))
                          }, {
                            trigger: _withCtx(() => [
                              _createVNode(_unref(NButton), {
                                size: "small",
                                secondary: "",
                                type: "error",
                                disabled: deviceStateClass(item) !== 'on'
                              }, {
                                default: _withCtx(() => _cache[41] || (_cache[41] = [
                                  _createTextVNode("关闭浏览器")
                                ])),
                                _: 2
                              }, 1032, ["disabled"])
                            ]),
                            default: _withCtx(() => [
                              _cache[42] || (_cache[42] = _createTextVNode(" 确定让该设备关闭浏览器吗？关闭后需要用户手动重新打开。 "))
                            ]),
                            _: 2
                          }, 1032, ["onPositiveClick"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              (deviceList.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, "暂无绑定设备"))
                : _createCommentVNode("", true)
            ]),
            (deviceTotalPages.value > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createVNode(_unref(NPagination), {
                    page: devicePage.value,
                    "onUpdate:page": [
                      _cache[8] || (_cache[8] = ($event: any) => ((devicePage).value = $event)),
                      loadDeviceList
                    ],
                    "page-count": deviceTotalPages.value,
                    "page-slot": 5,
                    size: "small"
                  }, null, 8, ["page", "page-count"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(NDrawer), {
      show: showHistory.value,
      "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((showHistory).value = $event)),
      placement: "right",
      width: "100vw",
      "mask-closable": false,
      "close-on-esc": true
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NDrawerContent), {
          title: "设备历史记录",
          closable: "",
          "body-style": { overflow: 'hidden' },
          "body-content-style": {
          height: '100%',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
        }
        }, {
          default: _withCtx(() => [
            (historyDevice.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["history-online-dot", deviceStateClass(historyDevice.value)])
                      }, null, 2),
                      _createElementVNode("span", {
                        class: _normalizeClass(["history-online-text", deviceStateClass(historyDevice.value)])
                      }, _toDisplayString(deviceStateText(historyDevice.value)), 3),
                      _createElementVNode("span", {
                        class: "history-device",
                        title: historyDevice.value.device_id
                      }, _toDisplayString(historyDevice.value.device_id), 9, _hoisted_53),
                      _createElementVNode("span", _hoisted_54, [
                        _createTextVNode(_toDisplayString(historyDevice.value.ip || '-') + " ", 1),
                        (historyDevice.value.region)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" · " + _toDisplayString(historyDevice.value.region), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      (historyDevice.value.last_seen_time)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, " 最后心跳 " + _toDisplayString(formatTime(historyDevice.value.last_seen_time)), 1))
                        : _createCommentVNode("", true),
                      (deviceStateClass(historyDevice.value) === 'closed')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, "浏览器已关闭"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_57, "当前打开 " + _toDisplayString(historyTabs.value.length) + " 个页面", 1))
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_unref(NButton), {
                        size: "small",
                        quaternary: "",
                        loading: historyLoading.value,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (loadHistory(historyPage.value, historyPageSize.value)))
                      }, {
                        default: _withCtx(() => _cache[43] || (_cache[43] = [
                          _createTextVNode(" 刷新 ")
                        ])),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    (historyTabs.value.length)
                      ? (_openBlock(), _createElementBlock("aside", _hoisted_60, [
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("span", null, "当前打开的页面（" + _toDisplayString(historyTabs.value.length) + "）", 1),
                            _cache[44] || (_cache[44] = _createElementVNode("span", { class: "history-side-hint" }, "高亮 = 正在浏览", -1))
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedHistoryTabs.value, (t, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["history-tab", { active: isCurrentTab(t) }]),
                                key: `${t.url}-${i}`
                              }, [
                                _createElementVNode("div", _hoisted_63, [
                                  _createElementVNode("a", {
                                    href: t.url,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    title: t.title || t.url
                                  }, _toDisplayString(t.title || t.url), 9, _hoisted_64),
                                  (isCurrentTab(t))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_65, "当前"))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", {
                                  class: "history-tab-url",
                                  title: t.url
                                }, _toDisplayString(t.url), 9, _hoisted_66)
                              ], 2))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("section", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(historyGroups, (g) => {
                          return _createElementVNode("button", {
                            key: g.key,
                            type: "button",
                            class: _normalizeClass(["history-filter", { active: historyFilter.value === g.key }]),
                            onClick: ($event: any) => (handleHistoryFilter(g.key))
                          }, [
                            _createTextVNode(_toDisplayString(g.label) + " ", 1),
                            _createElementVNode("span", _hoisted_70, _toDisplayString(historyGroupCounts.value[g.key] || 0), 1)
                          ], 10, _hoisted_69)
                        }), 64))
                      ]),
                      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "history-cols" }, [
                        _createElementVNode("span", { class: "col-time" }, "时间"),
                        _createElementVNode("span", { class: "col-event" }, "事件"),
                        _createElementVNode("span", { class: "col-body" }, "页面 / 内容"),
                        _createElementVNode("span", { class: "col-duration" }, "停留"),
                        _createElementVNode("span", { class: "col-ip" }, "IP / 地区")
                      ], -1)),
                      _createElementVNode("div", _hoisted_71, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyList.value, (h) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "history-item",
                            key: h.id
                          }, [
                            _createElementVNode("span", _hoisted_72, _toDisplayString(formatTime(h.start_time)), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass(["history-badge", 't-' + h.event_type])
                            }, _toDisplayString(eventLabel(h.event_type)), 3),
                            _createElementVNode("div", _hoisted_73, [
                              (h.event_type === 'page' && h.url)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "history-link",
                                    href: h.url,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    title: h.url
                                  }, _toDisplayString(h.title || h.url), 9, _hoisted_74))
                                : (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(h.url ? (h.title || h.url) : '-'), 1))
                            ]),
                            _createElementVNode("span", _hoisted_76, _toDisplayString(h.duration != null ? formatDuration(h.duration) : '-'), 1),
                            _createElementVNode("span", {
                              class: "history-ip",
                              title: h.ip || ''
                            }, [
                              _createTextVNode(_toDisplayString(h.ip || '-') + " ", 1),
                              (h.region)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" · " + _toDisplayString(h.region), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_77)
                          ]))
                        }), 128)),
                        (historyLoading.value && historyList.value.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, "加载中…"))
                          : (historyList.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, "暂无记录"))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("span", _hoisted_81, "共 " + _toDisplayString(historyTotal.value) + " 条", 1),
                        _createVNode(_unref(NPagination), {
                          page: historyPage.value,
                          "page-size": historyPageSize.value,
                          "item-count": historyTotal.value,
                          "page-sizes": [20, 50, 100, 200],
                          "page-slot": 7,
                          "show-size-picker": "",
                          "show-quick-jumper": "",
                          size: "small",
                          "onUpdate:page": handleHistoryPageChange,
                          "onUpdate:pageSize": handleHistoryPageSizeChange
                        }, null, 8, ["page", "page-size", "item-count"])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(NModal), {
      show: shotListVisible.value,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((shotListVisible).value = $event)),
      preset: "card",
      title: "截图记录",
      style: {"width":"1120px","max-width":"96vw"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("span", _hoisted_92, _toDisplayString(shotListDeviceId.value), 1),
          _createVNode(_unref(NButton), {
            size: "small",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (shotListVisible.value = false))
          }, {
            default: _withCtx(() => _cache[47] || (_cache[47] = [
              _createTextVNode("关闭")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (shotListLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_82, "加载中…"))
          : (shotList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, " 暂无截图。点击设备卡片上的“拍照”后，图片会自动弹出，同时保存在这里（每台设备保留最近 20 张）。 "))
            : (_openBlock(), _createElementBlock("div", _hoisted_84, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shotList.value, (s, i) => {
                  return (_openBlock(), _createElementBlock("figure", {
                    key: s.url,
                    class: "shot-card",
                    onClick: ($event: any) => (previewShot(s.url, s.ts))
                  }, [
                    _createElementVNode("div", _hoisted_86, [
                      _createElementVNode("img", {
                        src: s.url,
                        alt: "截图",
                        loading: "lazy"
                      }, null, 8, _hoisted_87),
                      (i === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_88, "最新"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("figcaption", _hoisted_89, [
                      _createElementVNode("span", _hoisted_90, _toDisplayString(formatTime(s.ts)), 1),
                      _cache[46] || (_cache[46] = _createElementVNode("span", { class: "shot-card-hint" }, "点击放大", -1))
                    ])
                  ], 8, _hoisted_85))
                }), 128))
              ]))
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(NModal), {
      show: screenshotVisible.value,
      "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((screenshotVisible).value = $event)),
      preset: "card",
      title: "设备截图",
      style: { width: '100vw', maxWidth: '100vw', height: '100vh', margin: '0', borderRadius: '0', overflow: 'hidden' },
      "content-style": { padding: '12px', height: 'calc(100vh - 124px)', display: 'flex', overflow: 'hidden' }
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("span", _hoisted_96, [
            _createTextVNode(_toDisplayString(screenshotDeviceId.value) + " ", 1),
            (screenshotAt.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" · " + _toDisplayString(formatTime(screenshotAt.value)), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_97, [
            (screenshotUrl.value)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "shot-open",
                  href: screenshotUrl.value,
                  target: "_blank",
                  rel: "noreferrer"
                }, "新窗口打开", 8, _hoisted_98))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_93, [
          (screenshotUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: screenshotUrl.value,
                class: "shot-img",
                alt: "设备截图"
              }, null, 8, _hoisted_94))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})